import { render, staticRenderFns } from "./vip_privilege_payment.vue?vue&type=template&id=d8da04fe&scoped=true&"
import script from "./vip_privilege_payment.vue?vue&type=script&lang=js&"
export * from "./vip_privilege_payment.vue?vue&type=script&lang=js&"
import style0 from "./vip_privilege_payment.vue?vue&type=style&index=0&id=d8da04fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8da04fe",
  null
  
)

export default component.exports